/**
 * 系统支持的语言列表
 *
 * serverCode: 后端的语言代码。
 */
export const Langs = {
  'zh-CN': {
    name: '简体中文',
    serverCode: 'zh_CN',
    shortName: '🇨🇳',
  },
  'zh-TW': {
    name: '繁体中文',
    serverCode: 'zh_TW',
    shortName: '🇭🇰',
  },
  'en-US': {
    name: 'English',
    serverCode: 'en_US',
    shortName: '🇬🇧',
  },
};
